export default __webpack_public_path__ + "static/media/backButton.581bcdbc.svg";